<h2 mat-dialog-title mat-dialog-draggable-title>
  {{'delete_all.screen_name' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid" appFocusFirstElement>
  <mat-dialog-content>
    <h5>{{'delete_all.success' | translate}}{{totalSuccess}}</h5>
    <h5>{{'delete_all.failed' | translate}}{{totalFailure}}</h5>
    <mat-table class="border-top-custom" *ngIf="totalFailure > 0" [dataSource]="dataSource"
               matSort (matSortChange)="sortData($event)"> width="100%">
      <!-- name -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>
          {{'delete_all.service_type_name' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" matTooltip="{{ element.name }}" (click)="$event.stopPropagation()">
          {{element.name}}
        </mat-cell>
      </ng-container>

      <!--error-->
      <ng-container matColumnDef="reason">
        <mat-header-cell *matHeaderCellDef >
          {{'delete_all.error' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" matTooltip="{{ element.reason }}" (click)="$event.stopPropagation()">
          {{element.reason}}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></mat-row>
    </mat-table>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="mt-2">
    <button mat-stroked-button color="primary" class="mr-3" type="button" (click)="close()">
      <mat-icon class="mr-0">cancel</mat-icon>{{'delete_all.close' | translate}}
    </button>
  </mat-dialog-actions>
</form>
